import React, { useState } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from "react-router-dom"

export default function Footer() {
    const location = useLocation();

    const [activeLink, setActiveLink] = useState(null);

    const handleClick = (link) => {
        setActiveLink(link);
    };

    return (
        <Container>
            <StyledLink to="/blog" $isActive={location.pathname === "/blog"}>blog</StyledLink>
            {/* <StyledAnchor 
                href="https://www.behance.net/vlnce" 
                onClick={() => handleClick("behance")}
                $isActive={activeLink === "behance"}
            >
                behance
            </StyledAnchor> */}
            <StyledAnchor 
                href="https://www.linkedin.com/in/vlnce" 
                onClick={() => handleClick("linkedin")}
                $isActive={activeLink === "linkedin"}
            >
                linkedin
            </StyledAnchor>
            <StyledAnchor 
                href="mailto:vinceryangarcia@gmail.com" 
                onClick={() => handleClick("email")}
                $isActive={activeLink === "email"}
            >
                email
            </StyledAnchor>
            
        </Container>
    )
}

const Container = styled.div`
    background: #000000;
    display: flex;
    justify-content: left;
    height:1.5em;
    align-items:center;
    padding: .2rem;

    @media screen and (max-width: 600px) {
        a {
            font-size: .8em;
        }
    }
`

const StyledAnchor = styled.a`
    padding-right: .5rem;
    color: ${({ $isActive }) => ($isActive ? 'black' : 'white')}; 
    text-decoration: none;

    &:hover {
        color: gray;
    }
`
const StyledLink = styled(Link)`
    padding-right: .5rem;
    color: ${({ $isActive }) => ($isActive ? 'black' : 'white')}; 
    text-decoration: none;

    &:hover {
        color: gray;
    }
`

